import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ areExamsLoaded, loadedPath, unloadedPath }) => {
  return areExamsLoaded ? (
    <Navigate to={loadedPath} replace />
  ) : (
    <Navigate to={unloadedPath} replace />
  );
};

export default ProtectedRoute;
